import { render, staticRenderFns } from "./specialCategoryProductPicker.vue?vue&type=template&id=189f81ba&scoped=true"
import script from "./specialCategoryProductPicker.vue?vue&type=script&lang=js"
export * from "./specialCategoryProductPicker.vue?vue&type=script&lang=js"
import style0 from "./specialCategoryProductPicker.vue?vue&type=style&index=0&id=189f81ba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "189f81ba",
  null
  
)

export default component.exports